import {Link} from "@tanstack/react-router";
import {SearchX} from "lucide-react";

import {Button} from "@/components/ui/button";

export default function NotFound() {
  return (
    <>
      <div className="text-center">
        <div className='flex justify-center'>
          <SearchX data-testid='error:not-found:icon' className='size-60 my-6 text-secondary-accent-light' />
        </div>
        <p data-testid='error:not-found:text' className="text-lg font-medium text-pretty text-gray-500 sm:text-xl/8">{"Sorry, we can't find the page you're looking for."}</p>
        <div data-testid='error:not-found:button' className="mt-10 flex items-center justify-center gap-x-6">
          <Link to={'/'}>
            <Button variant={'default'}>Back to home</Button>
          </Link>
        </div>
      </div>
    </>
  )
}